<template>
  <v-container fluid>
    <v-card>
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-col cols="10" class="text-left">
          <v-toolbar-title class="textwithbackground--text">
            {{ $t('Списки рассылок') }}
          </v-toolbar-title>
        </v-col>
        <v-col cols="2" class="text-right" />
      </v-toolbar>
      <general-error v-if="!!generalError" />
      <v-row class="px-2">
        <v-col>
          <v-data-table
              :headers="headers1"
              :items="lists"
              :items-per-page="itemsPerPage"
              disable-filtering
              item-key="mailingType"
              :loading="isLoading"
              :locale="systemLocale">

            <template v-slot:progress>
              <v-progress-linear :active="isLoading" color="loader" indeterminate />
            </template>

            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.description="{ item }">
              {{ $t(item.description) }}
            </template>

            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.emails="{ item }">
              <text-array-view
                  :display="item.emails"
                  :separator="''"
                  :label="''" />
            </template>

            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.mailingType="{ item }">
              <btn-icon-tip
                  v-if="isAdmin"
                  icon="edit"
                  icon-color="primaryiconbtn"
                  :tip="$t('Редактировать список')"
                  :disabled="isLoading"
                  @click="openEditMailingListDialog(item)" />
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
    <edit-mailing-list-dialog
        v-if="editMailingListDialog.show"
        :dialog-prop="editMailingListDialog"
        @close="closeDialog('editMailingListDialog')" />
  </v-container>
</template>

<script>

  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import TextArrayView from '@/components/reused/ui/TextArrayView.vue'
  import EditMailingListDialog from './EditMailingListDialog.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { mapActions, mapState } from 'vuex'
  import { MAILING } from '@/constants/store.js'

  export default {
    components: {
      BtnIconTip,
      GeneralError,
      EditMailingListDialog,
      TextArrayView
    },
    data () {
      return {
        isLoading: false,
        itemsPerPage: 20,
        editMailingListDialog: {
          item: null,
          callback: null,
          show: null
        }
      }
    },
    computed: {
      ...mapState(MAILING.NAMESPACE, {
        lists: state => (state[MAILING.STATE.MAILING_LISTS] || [])
      }),
      headers1 () {
        return [
          { text: this.$t('Описание'), align: 'start', sortable: true, value: 'description' },
          { text: this.$t('Список электронных адресов'), align: 'start', sortable: false, value: 'emails' },
          { text: this.$t('Действия'), align: 'start', sortable: false, value: 'mailingType' }
        ]
      }
    },
    created () {
      const vm = this
      vm.clearStore().then(() => {
        vm.getMailingLists()
      })
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(MAILING.NAMESPACE, {
        getMailingListsAction: MAILING.ACTIONS.GET_MAILING_LISTS,
        editMailingListItemAction: MAILING.ACTIONS.EDIT_MAILING_LIST_ITEM,
        clearMailingListsAction: MAILING.ACTIONS.CLEAR_MAILING_LISTS
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearMailingListsAction()
          ])
      },
      openEditMailingListDialog: function (item) {
        this.editMailingListDialog.item = item
        this.editMailingListDialog.callback = this.editMailingListItem
        this.editMailingListDialog.show = true
      },
      getMailingLists: async function () {
        try {
          this.isLoading = true
          await this.getMailingListsAction()
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      editMailingListItem: async function (item) {
        try {
          this.isLoading = true
          await this.editMailingListItemAction(item)
          await this.getMailingLists()
          this.isLoading = false
        } finally {
          this.isLoading = false
        }
      }
    }
  }
</script>
